// extracted by mini-css-extract-plugin
export default {"title":"ClaimTicketPage_title__CSv1g","header":"ClaimTicketPage_header__VuduA","status":"ClaimTicketPage_status__oXXgJ","actions":"ClaimTicketPage_actions__JG9C4"};